// extracted by mini-css-extract-plugin
export default {"tools__delete-icon":"Tools-modules__tools__delete-icon___aGpaW","tools__button":"Tools-modules__tools__button___doXPE"};